import * as React from 'react';
import i18n from '../i18n';
import { ErrorPageContent } from './ErrorPageContent';

export const ErrorPage: React.FC<{}> = () => (
  <ErrorPageContent errorTitle={i18n.t("errorPages.genericErrorTitle")} errorMessage={i18n.t("errorPages.genericErrorMessage")} />
);
